import { useState, useEffect } from "react"
import styles from '@/styles/productDetail/productReviews.module.scss'
import { Rate, Spin, Empty, message, Image } from 'antd'
import {
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';
import productApi from '@/service/modules/productApi'
import { debounce, paginationChange } from "@/utils/utils"
import ReviewConfig from "./components/ReviewConfig"
import Chart from "./components/Chart"
import getConfig from 'next/config'
import Link from "next/link";
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function CustomerReviews({ productID, hideDetail, hideTopPage = false, ReviewEmptyComponent }: any) {

  const defaultCustomerData = {
    review: [],
    reviewAvgRank: 0,
    reviewCount: 0,
    reviewSummary: {
      rating1: 0,
      rating2: 0,
      rating3: 0,
      rating4: 0,
      rating5: 0
    },
    chartValue: {},
    totalPages: 0
  }

  const defaultPages = 1
  const defaultPageSize = 3
  const defalueSort = ""

  const [customerData, setCustomerData]: any = useState(defaultCustomerData)
  const [sort, setSort] = useState(defalueSort)
  const [pages, setPages] = useState(defaultPages)
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getReviews()
  }, [pages, pageSize, sort])

  const getReviews = async () => {
    setLoading(true)
    const range = paginationChange(pages, pageSize)
    try {
      let res = await productApi.getCustomerReviews({
        productID: productID,
        sort: sort,
        start: range.start,
        rows: range.end
      })
      setLoading(false)
      if (res.data) {
        let newData = res.data
        setCustomerData(newData)
      }
    } catch (error: any) {
      setLoading(false)
      // message.error(error.message)
    }
  }

  const onpageChange = (page: number, pageSize: number) => {
    setPages(page)
    setPageSize(pageSize)
  }

  const sortChange = (event: any) => {
    setSort(event)
  }

  /**
   * 点赞
   * @param item 评论数据
   * @param isUseful 1点赞 0点踩
   * @returns 
   */
  const addVoteUseful = (item: any, isUseful: number) => debounce(async () => {
    if (item.isScore != 1 && item.isScore != 2) {
      const review = customerData.review.map((v: any) => {
        if (v.reviewID == item.reviewID) {
          if (isUseful == 1) {
            return { ...v, isScore: 1, scoreCount: v.scoreCount + 1 }
          } else if (isUseful == 0) {
            return { ...v, isScore: 2, stepCount: v.stepCount + 1 }
          }
        } else {
          return v
        }
      })
      setCustomerData((item: any) => {
        return { ...item, review }
      })
      try {
        let res = await productApi.addVoteUseful({
          reviewId: item.reviewID,
          isUseful
        })
        if (res.data) {
          // getReviews()
        }
      } catch (error: any) {
        getReviews()
        message.error(error.message)
        console.error(error)
      }
    }
  }, 0)

  return (
    <Spin spinning={loading}>
      {
        !hideDetail
        &&
        <div className={styles['info-box']}>
          <div className={`${styles['left']} ${styles['customer']}`}>
            <p className={styles['total']}>{customerData.reviewCount} Reviews</p>
            <div className={styles['rate']}>
              <Rate count={5} value={parseInt(customerData.reviewAvgRank.toFixed(0))} className={styles['rate-list']} allowHalf={true} disabled />
              <span className={styles['rating']}>{customerData.reviewAvgRank.toFixed(0)} overall rating</span>
            </div>
            <p className={styles['desc']}>Share your review and photos here. And 100-200 crazypoints will be <br />rewarded after the review approved.<br />(100 CrazyPoints Equals to $1)</p>
          </div>


          <div className={styles['right']}>
            <Chart reviewSummary={customerData.reviewSummary} reviewCount={customerData.reviewCount} />
          </div>
        </div>

      }
      <div className={`${styles['list-box']} ${styles['customer']}`}>
        {
          !hideTopPage
          &&
          <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={customerData.reviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={productID} activeTab={0} />
        }
        <div className={styles['review-list']}>
          {/* customer */}
          {
            customerData.review.length > 0
              ?
              customerData.review.map((item: any, index: number) => (
                <div className={styles['list-item']} key={index}>
                  <div className={styles['head']}>
                    {
                      item.customerID > 0
                        ?
                        <Link href={`/review/viewUserReview/${item.customerID}/1`} legacyBehavior>
                          <a className={styles['headImg']} rel="noopener noreferrer">
                            <Image
                              alt={'headImg'}
                              width={40}
                              height={40}
                              preview={false}
                              src={`${imageDomain}/svg/model-photos.svg`} />
                          </a>
                        </Link>
                        :
                        <div className={styles['headImg']} rel="noopener noreferrer">
                          <Image
                            alt={'headImg'}
                            width={40}
                            height={40}
                            preview={false}
                            src={`${imageDomain}/svg/model-photos.svg`} />
                        </div>
                    }
                    <div className={styles['review-info']}>
                      <div className={styles['top']}>
                        <span className={styles['username']}>{item.customerName}</span>
                        <Rate count={5} value={item.rate} style={{ fontSize: '16px', lineHeight: '1' }} allowHalf={true} disabled />
                      </div>
                      <p className={styles['review-time']}>{item.createTime}</p>
                    </div>
                  </div>
                  <div className={styles['content']}>
                    {item.detail}
                    {
                      !!(item.imgArray && item.imgArray.length > 0)
                      &&
                      <Image.PreviewGroup>
                        <div className={styles['img-list']}>
                          {
                            item.imgArray.map((img: string) => (
                              <div className={styles['commentImg']} key={img}>
                                <Image
                                  src={img}
                                  width={100}
                                  height={100}
                                  alt={img}
                                />
                              </div>
                            ))
                          }
                        </div>
                      </Image.PreviewGroup>
                    }

                  </div>
                  <div className={styles['user-setting']}>
                    <div className={styles['recommends-box']}>
                      <p className={styles['tips']}>Recommends this product ?</p>
                      <div className={styles['val']}>
                        {
                          item.recommend == 1
                            ?
                            <CheckCircleOutlined className={styles['checkCircleOutlined']} />
                            :
                            <CloseCircleOutlined className={styles['closeCircleOutlined']} />
                        }
                        <span>{item.recommend == 1 ? "Yes" : 'No'}</span>
                      </div>
                    </div>
                    <div className={styles['helpful-box']}>
                      <span className={styles['helpfulTips']}>Helpful?</span>
                      <div className={styles['like-box']} onClick={addVoteUseful(item, 1)}>
                        <LikeOutlined className={`${styles['like-icon']} ${item.isScore == 1 && styles['active']}`} />
                        <span className={`${styles['val']} ${item.isScore == 1 && styles['active']}`}>{item.scoreCount}</span>
                      </div>
                      <div className={styles['dislike-box']} onClick={addVoteUseful(item, 0)}>
                        <DislikeOutlined className={`${styles['like-icon']} ${item.isScore == 2 && styles['active']}`} />
                        <span className={`${styles['val']} ${item.isScore == 2 && styles['active']}`}>{item.stepCount}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              :
              ReviewEmptyComponent
                ?
                <ReviewEmptyComponent />
                :
                <Empty description="* Get double crazypoints if your review is one of the first three approved!" />
          }
        </div>
        {
          customerData.reviewCount > 3
          &&
          <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={customerData.reviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={productID} activeTab={0} />
        }
      </div>
    </Spin>
  )
}